import React from 'react'
import Slider from "react-slick";

export default function RishikeshNearby({ nearbyData }) {
    const settings = {
        dots: true,
        arrows: false,
        infinite: true,
        speed: 1100,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        pauseOnHover: false,
        cssEase: "ease",
        responsive: [

            {
                breakpoint: 991,
                settings: { slidesToShow: 3, },
            },
            {
                breakpoint: 767,
                settings: { slidesToShow: 2, },
            },
            {
                breakpoint: 599,
                settings: { slidesToShow: 1, },
            },
        ],
    };

    return (
        <>
            <section className="rishikesh-nearby">
                <div className="big-container">
                    <div className="row">
                        <div className="col-lg-12">
                            <h4 className='heading center-heading'>Nearby Attractions</h4>
                            <Slider {...settings} className="nearby-slider">
                                {nearbyData?.map((item, index) => (
                                    <div key={index}>
                                        <div className='nearby-box'>
                                            <img src={item?.img} loading="lazy" className="img-responsive" alt={item?.title} />
                                            <p>{item?.title}</p>
                                        </div>

                                        <div className='nearby-content'>
                                            <div className='nearby-distance'>
                                                <img src='/image/nearby-icon-1.webp' alt={item?.title} />
                                                <span>{item?.distance}</span>
                                            </div>
                                            <label className='heading'>{item?.title}</label>
                                            <span>{item?.description}</span>
                                        </div>
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
